import { useQuery } from 'react-query';
import { trackPromise } from 'react-promise-tracker';
import { getMigratorsList } from '..';
export const useGetMiratorsList = () => useQuery(['GetMigratorList'], () => trackPromise(getMigratorsList()), {
    cacheTime: 0
});
